export enum ChatActions {
  MESSAGE_CHAT = 'messageChat',
  CHECK_MESSAGES = 'setMessagesChecked',
  JOIN_CHAT = 'joinChat',
  LEAVE_CHAT = 'leaveChat',
  CRM_SUBSCRIBE_CHAT_LIST = 'chat:crm:list:subscribe',
  CRM_UNSUBSCRIBE_CHAT_LIST = 'chat:crm:list:unsubscribe',
}

export enum ChatEvents {
  NEW_MESSAGE = 'newMessage',
  CHECKED_MESSAGES = 'checkedMessages',
  CRM_CHAT_LIST_INVALIDATED = 'chat:crm:list:invalidated',
}

export enum MessageTypeEnum {}

export enum MessageFileTypeEnum {
  FILE = 'file',
  IMAGE = 'image',
}

export enum FileType {
  IMAGE = 'image/*',
  AUDIO = 'audio/*',
  VIDEO = 'video/*',
  PDF = 'application/pdf',
}
